module.exports = __webpack_public_path__ + "img/apoio-ucr.f5513156.png";